<template>
  <j-modal :title="title"
           :width="width"
           :visible="visible"
           switchFullscreen
           @ok="debouncedHandleOk"
           :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
           @cancel="handleCancel"
           cancelText="关闭">
    <gift-product-info-form ref="realForm"
                            @ok="submitCallback"
                            :disabled="disableSubmit"
                            :vendorList="vendorList" 
                            :appList="appList"></gift-product-info-form>
  </j-modal>
</template>

<script>
import GiftProductInfoForm from './GiftProductInfoForm'
import { debounce } from 'lodash'; // 引入 lodash 的 debounce 方法
export default {
  name: 'GiftProductInfoModal',
  components: {
    GiftProductInfoForm,
  },
  props: {
    vendorList: {
      type: Array,
    },
    appList: {
      type: Array,
    },
  },
  data() {
    return {
      title: '',
      width: 900,
      visible: false,
      disableSubmit: false,
    }
  },
  methods: {
    add(app) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.add(app)
      })
    },
    edit(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.edit(record)
      })
    },
    copy(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.copy(record)
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.$refs.realForm.submitForm()
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
  },
  created () {
    // 使用 debounce 包装 handleOk 方法
    this.debouncedHandleOk = debounce(this.handleOk, 500); // 500ms 内只触发一次
  }
}
</script>